<template>
  <div class="login-wrap flex bg-grey-lightest"
       :style="{
        backgroundImage: 'url(' + $t('login.ad_bg_image') + ')',
        backgroundSize:
          $t('login.ad_bg_size') == '100%' ? 'cover' : $t('login.ad_bg_size'),
      }">
    <div class="login-container">
<!--      <header class="flex flex-row">-->
<!--        <div class="header-logo flex-1">-->
<!--          <img-->
<!--            :src="$t('login.logo')"-->
<!--            :alt="$t('website.title')"-->
<!--            style="margin: 15px 40px"-->
<!--          />-->
<!--          <span style="margin-left: -20px; font-weight: bold">ScaleDesk</span>-->
<!--        </div>-->
<!--      </header>-->
      <div>
        <img
            :src="$t('login.logo')"
            :alt="$t('website.title')"
            style="margin: 30px 30px 0; width: 250px"
          />
      </div>
      <div
        class="login-form"
        v-if="type == 'login'"
      >
<!--        <h1 class="login-t">Log In</h1>-->
        <div class="error" v-if="error">{{ error.message }}</div>
        <form @submit.prevent="login">
          <div class="form-inline">
<!--            <label for="email">{{ $t("login.email_label") }}</label>-->
            <div>
              <input
                id="email"
                type="email"
                :placeholder="$t('login.email_placeholder')"
                v-model="email"
              />
            </div>
          </div>
          <div class="form-inline" v-if="showPassword">
<!--            <label for="pwd">{{ $t("login.password_label") }}</label>-->
            <div>
              <input
                id="pwd"
                type="password"
                :placeholder="$t('login.password_placeholder')"
                v-model="password"
              />
            </div>
          </div>
          <div class="form-inline">
            <a style="cursor: default" @click="clickForgetPassword"
              >forget password?</a
            >
          </div>
          <div class="form-inline">
            <button class="submit primary login-btn" :disabled="loading">
              <i class="material-icons-outlined">login</i>
              {{ loading ? "Loading" : "Login" }}
            </button>
          </div>
        </form>

        <div class="hr"></div>

        <div class="other-login">
          <button @click="googleLogin" class="google-login login-btn">
            <div class="icon">
              <svg fill="#fff" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="16px" height="16px">    <path d="M 15.003906 3 C 8.3749062 3 3 8.373 3 15 C 3 21.627 8.3749062 27 15.003906 27 C 25.013906 27 27.269078 17.707 26.330078 13 L 25 13 L 22.732422 13 L 15 13 L 15 17 L 22.738281 17 C 21.848702 20.448251 18.725955 23 15 23 C 10.582 23 7 19.418 7 15 C 7 10.582 10.582 7 15 7 C 17.009 7 18.839141 7.74575 20.244141 8.96875 L 23.085938 6.1289062 C 20.951937 4.1849063 18.116906 3 15.003906 3 z"/></svg>
            </div>
            Login with Google
          </button>
          <!--<button @click="githubLogin">Login with Github</button>-->
        </div>
      </div>
      <div
        class="login-form"
        v-if="type == 'forgetPassword'"
      >
<!--        <h1 class="login-t">Reset Password</h1>-->
        <div class="error" v-if="resetPasswordError">
          {{ resetPasswordError }}
        </div>
        <!-- <form> -->
        <div class="form-inline">
<!--          <label>{{ $t("login.email_label") }}</label>-->
          <div>
            <input
              :placeholder="$t('login.email_placeholder')"
              v-model="resetPasswordEmail"
            />
          </div>
        </div>
        <div class="form-inline">
          <a style="cursor: default" @click="clickLogin">go to login</a>
        </div>
        <div class="form-inline">
          <button
            class="submit primary login-btn"
            :disabled="resetPasswordLoading"
            @click="onResetPassword"
          >
            <i class="material-icons-outlined">vpn_key</i>
            {{ resetPasswordLoading ? "Loading" : "Reset Password" }}
          </button>
        </div>
        <!-- </form> -->
      </div>
    </div>
<!--    <div-->
<!--      class="login-ad-container flex-1"-->
<!--      :style="{-->
<!--        backgroundImage: 'url(' + $t('login.ad_bg_image') + ')',-->
<!--        backgroundSize:-->
<!--          $t('login.ad_bg_size') == '100%' ? 'cover' : $t('login.ad_bg_size'),-->
<!--      }"-->
<!--    >-->
<!--      <div-->
<!--        style="margin: 75px 100px 0; height: calc(100vh - 300px); color: #fff"-->
<!--      >-->
<!--        <h3-->
<!--          style="-->
<!--            font-size: 48px;-->
<!--            font-weight: 800;-->
<!--            margin-bottom: 20px;-->
<!--            max-width: 700px;-->
<!--          "-->
<!--        >-->
<!--          {{ $t("login.ad_content") }}-->
<!--        </h3>-->
<!--        &lt;!&ndash; <h3 style="text-transform: uppercase; font-family: avenir-next-light; max-width: 600px">online timeline maker.</h3> &ndash;&gt;-->
<!--        &lt;!&ndash; <p style="margin-top: 50px; max-width: 600px">Make professional timelines in minutes. Quickly update and share your slides online with the web's simplest timeline.</p> &ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {
  auth,
  GoogleAuthProvider,
  GithubAuthProvider,
} from "@/vendor/firebase";
import { httpGetNoToken } from "@/http/http";
import * as utils from "@/utils/utils";

export default {
  data() {
    return {
      type: "login",
      email: "",
      password: "",
      error: {},
      loading: false,
      resetPasswordEmail: null,
      resetPasswordError: null,
      resetPasswordLoading: null,
      showPassword: false,
      projectId: null,
      roleId: null,
    };
  },
  beforeMount() {
    this.projectId = this.$route.query.project_id;
    this.roleId = this.$route.query.role_id;
  },
  mounted() {
    const email = this.getQueryVariable("email");
    if (email) {
      this.signWithEmailLink(email);
    }
    if (!auth.isSignInWithEmailLink(window.location.href)) {
      this.showPassword = true;
    }
  },
  methods: {
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    signWithEmailLink(email) {
      auth
        .signInWithEmailLink(email, window.location.href)
        .then((result) => {
          this.$router.replace({ name: "home" });
        })
        .catch((error) => {
          this.error.message = "please input your password";
          this.showPassword = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    signInWithEmailAndPassword(email, password) {
      auth
        .signInWithEmailAndPassword(email, password)
        .then(() => {
          this.$router.replace({
            name: "home",
            query:
              this.projectId && this.roleId
                ? { project_id: this.projectId, role_id: this.roleId }
                : {},
          });
        })
        .catch((error) => {
          this.error = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async login() {
      this.loading = true;
      this.error = {};
      if (!this.email) {
        this.error.message = "please input your email";
        this.loading = false;
      } else if (this.email && this.password) {
        this.signInWithEmailAndPassword(this.email, this.password);
      } else if (auth.isSignInWithEmailLink(window.location.href)) {
        this.signWithEmailLink(this.email);
      } else {
        this.showPassword = true;
        this.error.message = "please input your password";
        this.loading = false;
      }
    },
    async googleLogin() {
      this.error = "";
      auth
        .signInWithPopup(GoogleAuthProvider)
        .then(() => {
          this.$router.replace({
            name: "home",
            query:
              this.projectId && this.roleId
                ? { project_id: this.projectId, role_id: this.roleId }
                : {},
          });
        })
        .catch((error) => {
          this.error = error;
          if (error.code === "auth/account-exists-with-different-credential") {
            this.error =
              "You have signed up with a different provider for that email.";
          }
        });
    },
    async githubLogin() {
      this.error = "";
      auth
        .signInWithPopup(GithubAuthProvider)
        .then(() => {
          this.$router.replace({
            name: "home",
            query:
              this.projectId && this.roleId
                ? { project_id: this.projectId, role_id: this.roleId }
                : {},
          });
        })
        .catch((error) => {
          this.error = error;
          if (error.code === "auth/account-exists-with-different-credential") {
            this.error =
              "You have signed up with a different provider for that email.";
          }
        });
    },
    clickForgetPassword: function () {
      this.type = "forgetPassword";
    },
    clickLogin: function () {
      this.type = "login";
    },
    onResetPassword: function () {
      this.resetPasswordError = null;
      if (
        !this.resetPasswordEmail ||
        !utils.validateEmail(this.resetPasswordEmail)
      ) {
        this.resetPasswordError = "invalid email";
        return;
      }
      this.resetPasswordLoading = true;
      httpGetNoToken("send_password_reset_email", {
        email: this.resetPasswordEmail,
      })
        .then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "a password reset email has been sent to your email",
            });
          } else {
            this.resetPasswordError = response.message;
          }
        })
        .finally(() => {
          this.resetPasswordLoading = false;
        });
    },
  },
};
</script>
